/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ICitaTechnologiasSalud, IGraficaItem } from "@/modules/Asistencial/interfaces"
import type { IConfGraficas, IConfGraficaspercentiles } from "@/modules/Configuracion/interfaces"
import type { IComponentGraficasItems } from "@/modules/Configuracion/interfaces/IFormComponent"

function convertirSeriesApexAChartJS(series: any[]): any[] {
  return series.map(serie => {
    const type = serie.type === 'line' ? serie.data.length > 1 ? 'line' : 'scatter' : serie.type;
    return {
      label: serie.nameSerie,
      data: serie.data.map((p: any) => ({ x: p.x, y: p.y })),
      borderColor: serie.color,
      backgroundColor: serie.color,
      fill: false,
      tension: 0.3,
      showLine: type !== 'scatter',
      pointRadius: type === 'scatter' ? 4 : 0,
      type: type,
      ...serie.options // Agregar opciones adicionales si existen
    }
  })
}
const generarOptionsGraficas = (type: string, id: string, titulo: string, chartDatasets, xLabel: string, yLabel: string) => {
  return {
      id,
      type,
      data: {
        datasets: chartDatasets
      },
      options: {
        responsive: true,
        plugins: {
          // zoom: {
          //   zoom: {
          //     wheel: {
          //       enabled: true
          //     },
          //     drag: {
          //       enabled: true // Zoom táctil
          //     },
          //     pinch: {
          //       enabled: true // Zoom táctil
          //     },
          //     mode: 'xy' // Zoom en ambas direcciones
          //   },
          // },
          title: {
            display: true,
            text: titulo
          }
        },
        scales: {
          x: {
            type: 'linear',
            position: 'bottom',
            title: {
              display: true,
              text: xLabel
            }
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: yLabel
            }
          }
        }
      }
    }
}
export function createGrafic(
  dataSource: IConfGraficas[],
  pesos: any[],
  technologias: ICitaTechnologiasSalud[],
  graficasList?: IComponentGraficasItems[] | null
): IGraficaItem[] {
  const graficasData: IGraficaItem[] = []
  if (graficasList && graficasList.length > 0) {
    dataSource = dataSource.filter(e =>  graficasList.some( a => a.codigo == e.cogrCodigo ))
  }
  const isPrenatal = technologias?.some( item => item.contratoxservicio?.servicio?.coseIsPrenatal == 1)
  for (const grafica of dataSource) {
    const config = JSON.parse(grafica.cogrConfiguracion)
    if ((isPrenatal && !config.isPrenatal) || (!isPrenatal && config.isPrenatal)) continue
    const dataPeso = (grafica.percentiles as IConfGraficaspercentiles[]).map(item => JSON.parse(item.cogpData))
    const newPesos = pesos
    const ultSerie = config.series[config.series.length-1]
    const graficItem = graficasList && graficasList.length > 0 ? graficasList.find( a => a.codigo == grafica.cogrCodigo ) : null
    if(graficItem)
    {
      const campoY = document.getElementById(graficItem.parametroY as string) as HTMLInputElement
      const camppX = document.getElementById(graficItem.parametroX as string) as HTMLInputElement
      if(campoY && camppX){
        const valueYParsed = parseFloat(campoY.value)
        const valueXParsed = parseFloat(camppX.value)
        newPesos.push({ [ultSerie.y]: valueYParsed, [ultSerie.x]: valueXParsed })
      }
    }
    const puntosPaciente = newPesos
      .map((elemento: any) => ({ x: elemento[ultSerie.x], y: elemento[ultSerie.y] }))
      .filter((elemento: any) => elemento.x && elemento.y)
    const datosPaciente = config.singlePoint ? puntosPaciente.slice(-1) : puntosPaciente
    const series = [] as unknown[]
    for (const serie of config.series) {
        series.push({
          nameSerie: serie.nameSerie,
          color: serie.color,
          type: serie.type,
          data: ultSerie.nameSerie == serie.nameSerie? datosPaciente: dataPeso.map((elemento: any) => { return {x:elemento[serie.x],y:elemento[serie.y]}}),
          options: serie.options || {}
        })
    }
    const chartDatasets = convertirSeriesApexAChartJS(series)
    const graficaOptions = generarOptionsGraficas(config.type, config.id + new Date().getTime(), grafica.cogrTitulo as string, chartDatasets, config.xLabel, config.yLabel)
    graficasData.push({ titulo: graficaOptions.options.plugins.title.text , options: graficaOptions } )
  }
  return graficasData
}
